<template>
  <div style="display:flex; justify-content:center; margin-top:100px">
    <div style="width:100%">
      <div style="width:100%; background-color:#EDFBFF;display: flex;justify-content: center; position:relative">
        <!-- <img src="@/assets/images/activitybanner.png" style="width:100%"> -->
        <div style="width:100%; background-color: #E5F5FF; position: relative;height: 35vw;">
          <img src="@/assets/images/activitybanner1.png" style="width:50%; position: absolute; top: 100px; left: 50%;">
        </div>

        <div style="position:absolute;top: 35%; left:15%">
          <span
            style="font-size:48px; color:black; font-family: 'SourceHanSansSC-bold'; font-weight:bold">NZONE手机日常终端服务</span>

        </div>
      </div>

      <div style="margin-top:75px">
        <p class="content2">服务内容</p>
      </div>

      <div style="display:flex; justify-content:center">
        <div style="margin-top:50px; display:flex; justify-content:space-around; align-items:center; width:1100px">
          <div class="activity">
            <img src="@/assets/images/activity5.png" style="width:270px">
            <div class="position">
              <img src="@/assets/images/activity2/repair.png" class="img">

              <div style="margin-top:50px"><span class="font">外屏维修</span>

              </div>

            </div>
          </div>
          <div class="activity">
            <img src="@/assets/images/activity6.png" style="width:270px">
            <div class="position">
              <img src="@/assets/images/activity2/protect.png" class="img">

              <div style="margin-top:50px"><span class="font">个性化贴膜</span>

              </div>

            </div>
          </div>
          <div class="activity">
            <img src="@/assets/images/activity7.png" style="width:270px">
            <div class="position">
              <img src="@/assets/images/activity2/battery.png" class="img">

              <div style="margin-top:50px"><span class="font">电池一口价</span>

              </div>

            </div>
          </div>

        </div>

      </div>
      <hr />

      <div style="margin-top:50px">
        <p class="content2">外屏维修</p>
        <div style="display:flex; justify-content:center">
          <div style=" display:flex; justify-content:space-around; align-items:flex-start; width:1100px">
            <div style="width:300px;text-align: left;">
              <p class="content" style="color:#646464">外屏维修参与机型和价格:</p>
              <div>
                <div style="display:flex; justify-content:space-between;align-items:center">
                  <div class="content">NZONE S7 Pro+ 5G</div>
                  <div class="content">269</div>
                </div>
                <div style="display:flex; justify-content:space-between;align-items:center;margin-top: 20px;">
                  <div class="content">NZONE S7 Pro 5G</div>
                  <div class="content">219</div>

                </div>
                <div style="display:flex; justify-content:space-between;align-items:center;margin-top: 20px">
                  <div class="content">NZONE S7</div>
                  <div class="content">219</div>

                </div>
              </div>
            </div>
            <div style="width:300px;text-align: left;">
              <p class="content" style="color:#646464">外屏维修参与条件:</p>
              <div>
                <div class="content">官方产品</div>
                <div class="content" style="margin-top: 20px">无私修私拆、变形、主板无进液</div>
                <div class="content" style="margin-top: 20px">仅屏幕外层玻璃</div>
                <div class="content" style="margin-top: 20px">内屏功能完好</div>

              </div>
            </div>
          </div>
        </div>

      </div>

      <div>
        <p class="content" style="margin-top:50px;color:#646464">外屏维修参与机型仅以上这三款</p>
        <p class="content" style="margin-top:20px;color:#646464">说明：部分机型需同步更换电池，具体以服务店检测结果为准</p>
      </div>

      <hr />

      <div style="margin-top:50px">
        <p class="content2">个性化贴膜</p>
        <div style="display:flex; justify-content:center">
          <div style="margin-top:50px; display:flex; justify-content:space-around; align-items:center; width:1200px">
            <div style="width:200px; text-align:center">
              <img src="@/assets/images/activity2/gexinghua.png">
              <p class="content" style="margin-top:20px">个性后壳保护膜</p>
              <div><span class="content" style="margin-top:20px;color:#646464">活动价:￥</span><span class="content"
                  style="margin-top:20px;color: #F53434">29.9</span></div>

            </div>
            <div style="width:200px; text-align:center">
              <img src="@/assets/images/activity2/gaoqing.png">
              <p class="content" style="margin-top:20px">高清屏幕保护膜</p>
              <div><span class="content" style="margin-top:20px;color:#646464">活动价:￥</span><span class="content"
                  style="margin-top:20px;color: #F53434">29.9</span></div>

            </div>
            <div style="width:200px; text-align:center">
              <img src="@/assets/images/activity2/kanglanguang.png">
              <p class="content" style="margin-top:20px">抗蓝光屏幕保护膜</p>
              <div><span class="content" style="margin-top:20px;color:#646464">活动价:￥</span><span class="content"
                  style="margin-top:20px;color: #F53434">39.9</span></div>

            </div>
            <div style="width:200px; text-align:center">
              <img src="@/assets/images/activity2/mosha.png">
              <p class="content" style="margin-top:20px">磨砂屏幕保护膜</p>
              <div><span class="content" style="margin-top:20px;color:#646464">活动价:￥</span><span class="content"
                  style="margin-top:20px;color: #F53434">39.9</span></div>
            </div>
          </div>

        </div>

        <div style="display:flex; justify-content:center; margin-top: 50px;">
          <div style=" display:flex; justify-content:space-around; align-items:flex-start; width:1100px">
            <div style="width:350px;text-align: left;">
              <div>
                <div class="content" style="height:40px;display: flex; align-items: flex-end;">高清屏幕保护膜+个性后壳保护膜</div>
                <div class="content" style="margin-top: 20px;height: 40px;display: flex; align-items: flex-end;">
                  抗蓝光屏幕保护膜+个性后壳保护膜</div>
                <div class="content" style="margin-top: 20px;height:40px;display: flex; align-items: flex-end;">
                  磨砂屏幕保护膜+个性后壳保护膜</div>
              </div>
            </div>
            <div style="width:300px;text-align: left;">
              <div>
                <div style="height:40px; display: flex; align-items: flex-end;">
                  <span class="content">综合优惠价:￥</span>
                  <span class="font_title">49.9</span>
                </div>
                <div style="height:40px;margin-top: 20px; display: flex; align-items: flex-end;">
                  <span class="content">综合优惠价:￥</span>
                  <span class="font_title">59.9</span>
                </div>
                <div style="height:40px;margin-top: 20px; display: flex; align-items: flex-end;">
                  <span class="content">综合优惠价:￥</span>
                  <span class="font_title">59.9</span>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div style="margin-top:50px">
        <p class="content2">电池一口价</p>


        <div style="display:flex; justify-content:center; margin-top: 50px;">
          <div style=" display:flex; justify-content:space-around; align-items:flex-end; width:900px">
            <div style="width:350px;text-align: left;">
              <p class="content" style="color:#646464">电池一口价参与机型和价格:</p>
              <div>
                <div class="content" style="height:40px">NZONE S7 Pro+ 5G</div>
                <div class="content" style="margin-top: 20px;height: 40px">
                  NZONE S7 Pro 5G</div>
                <div class="content" style="margin-top: 20px;height:40px">
                  NZONE S7</div>
              </div>
            </div>
            <div style="width:100px;text-align: left;">
              <div>
                <div style="height:40px; ">
                  <span class="content">129</span>

                </div>
                <div style="height:40px;margin-top: 20px; ">
                  <span class="content">129</span>

                </div>
                <div style="height:40px;margin-top: 20px; ">
                  <span class="content">129</span>

                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <p class="content" style="margin-top:50px;color:#646464">说明：所有内容和报价最终以NZONE授权服务中心现场确认为准</p>
      </div>

    </div>

  </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  methods: {
    returnIndex() {
      this.$router.push("/");
    },
  },
  setup() {
    return {};
  },
});
</script>
<style scoped>
.title {
  font-size: 48px;
  font-style: SourceHanSansSC;
  color: #010101;
  font-weight: bold;
  letter-spacing: 2px;
}

.content {
  font-size: 20px;
  font-family: "SourceHanSansSC-regular";
  color: #010101;
  letter-spacing: 1px;
}

.content2 {
  font-size: 36px;
  font-family: "SourceHanSansSC-regular";
  color: #010101;
  /* font-weight: bold; */
  margin-top: 30px;
}

.content3 {
  font-size: 16px;
  font-style: SourceHanSansSC-regular;
  color: #010101;
  margin-left: 40px;
  line-height: 35px;
}

.div2 {
  max-width: 1250px;
  text-align: center;
}

.div3 {
  max-width: 1250px;
  text-align: left;
}

hr {
  width: 80%;
  margin-top: 100px;
  margin-bottom: 100px;
}

.activity {
  position: relative;
}

.font {
  color: white;
  font-size: 20px;
  font-family: "SourceHanSansSC-regular";
  line-height: 30px;
}

.font_title {
  color: rgba(245, 52, 52, 1);
  font-size: 32px;
  font-family: "SourceHanSansSC-regular";
}

.position {
  position: absolute;
  top: 30px;
  /* left: 20px; */
  width: 100%;
  /* margin-right: 20px; */
  text-align: center;
}

.img {
  width: 100px;
  height: auto;
}
</style>
